export async function toggleWishlist(button) {
    const productId = Number(button.dataset.productId || button.dataset.productWishlist);
    if (!Number.isSafeInteger(productId) || productId <= 0 || button.disabled) return null;

    const saved = button.classList.contains('is-added');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
        const response = await fetch(
            saved
                ? '/index.php?route=account/wishlist/remove'
                : '/index.php?route=account/wishlist/add',
            {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                body: new URLSearchParams({ product_id: String(productId) }),
            },
        );
        if (!response.ok) throw new Error(`Wishlist request failed with HTTP ${response.status}`);
        const result = await response.json();
        if (result.redirect) {
            window.location.assign(result.redirect);
            return null;
        }
        if (!result.success)
            throw new Error(result.error || 'Der Merkzettel ist gerade nicht verfügbar.');

        const nextSaved = !saved;
        button.classList.toggle('is-added', nextSaved);
        document.dispatchEvent(
            new CustomEvent('zirbelino:wishlist:change', {
                detail: { productId, saved: nextSaved },
            }),
        );
        return { productId, saved: nextSaved, result };
    } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
    }
}
